import { Controller, useFormContext } from "react-hook-form";

export const SingleSelect = (props) => {
  const {
    label,
    placeholder,
    dir,
    className,
    registration,
    error,
    options,
    isLoading = false,
    disabled = false,
    leftAddon,
    name,
    rules,
  } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FieldWrapper label={label} error={errors[name]}>
      <div className="flex gap-2">
        <CustomSelect
          dir={dir}
          className={`${errors[name] && "ring-red-300"}`}
          placeholder={placeholder}
          disabled={isLoading || disabled}
          registration={registration}
          options={options}
          control={control}
          name={name}
          rules={rules}
        />
      </div>
    </FieldWrapper>
  );
};

export const CustomSelect = ({
  options,
  registration = {},
  isLoading = false,
  control,
  name,
  rules,
  ...props
}) => {
  return (
    <Controller
      rules={rules}
      name={`${name}`}
      control={control}
      render={({ field }) => {
        const { onChange, value } = field;

        const handleRadioChange = (event) => {
          onChange(event.target.value);
        };
        return (
          <div
            {...props}
            {...registration}
            className={"w-full  py-1 text-md text-gray-600 "}
          >
            {options.map((option) => {
              return (
                <label
                  key={option.value}
                  className="flex items-start space-x-2 text-md text-gray-600 my-1 w-fit group"
                >
                  <input
                    type="radio"
                    value={option.value}
                    checked={value == option.value}
                    onChange={handleRadioChange}
                    className="hidden"
                  />
                  <div
                    className={`w-5 h-5 rounded-full border-2
                    inline-flex justify-center items-center group-hover:border-bgBlue cursor-pointer transition-all duration-300 ease-out
                       ${
                         value == option.value
                           ? " border-bgBlue"
                           : "border-gray-600"
                       }
                    }`}
                  >
                    <div
                      className={`w-3 h-3 rounded-full   ${
                        value == option.value ? " bg-bgBlue" : "hidden"
                      }`}
                    ></div>
                  </div>
                  <span className=" cursor-pointer">{option.label}</span>
                </label>
              );
            })}
          </div>
        );
      }}
    />
  );
};
export const FieldWrapper = (props) => {
  const { label, className, error, children, hidden, description } = props;
  return (
    <div className={"mb-5 flex-1  p-2  shadow shadow-gray-400 rounded-lg"}>
      <label className={"block text-md font-medium text-gray-800 text-right"}>
        {label}
        <div className={label && "mt-1"}>{children}</div>
      </label>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className=" text-sm font-semibold text-red-500 text-right "
        >
          {error.message}
        </div>
      )}
      {/*  <p className="mt-1 text-xs text-gray-500">{description}</p> */}
    </div>
  );
};
